import { createApiSlice } from '@/shared/features/query/config/query.build';
import type { ReduxQueryClient } from '@/shared/features/query/domain/interfaces/QueryClient';
import type { AppDispatch } from '@/app/store/store';
import { executeQuery } from '@/shared/features/query/utils/queryUtils';
import { getApiBaseUrl } from '@/core/utils/apiUtils';
import type { MatchingSetResponseDTO } from '../dto/matchingSet.dto';
import { matchingSetDtoToMatchingSet } from '../mappers/matchingSet.mapper';
import type { MatchingSetRepository } from '../../domain/interfaces/MatchingSetRepository';
import type { MatchingSet } from '../../domain/models/MatchingSet';

export type GetMatchingSetArgs = {
  designId: string;
};

const matchingSetApiSlice = createApiSlice({
  clientId: 'matchingSetApi',
  tagTypes: ['MatchingSet'],
  endpoints: {
    getMatchingSet: {
      url: (args: unknown) => {
        const { designId } = (args || {}) as GetMatchingSetArgs;
        return `${getApiBaseUrl()}/matching-set/design-group/${designId}`;
      },
      method: 'GET',
      transformResponse: (response: unknown): Record<string, unknown> => {
        const dto = (response ?? {}) as MatchingSetResponseDTO;
        return matchingSetDtoToMatchingSet(dto) as unknown as Record<string, unknown>;
      },
      keepUnusedDataFor: 120,
    },
  },
});

export const matchingSetApi = matchingSetApiSlice.queryClient;
export const matchingSetApiRedux = matchingSetApiSlice.queryClient as ReduxQueryClient;

export class MatchingSetAdapter implements MatchingSetRepository {
  constructor(private readonly dispatch: AppDispatch) {}

  async fetchMatchingSet(designId: string): Promise<MatchingSet> {
    const initiateResult = matchingSetApi.endpoints.getMatchingSet.initiate({ designId });
    const plain = await executeQuery<MatchingSet>(initiateResult, this.dispatch);
    return plain;
  }
}
